import { TabCountBadge } from './TabCountBadge';
import type { AssetTabId, AssetTabItem } from './assetTabs';

interface AssetsTabListProps {
  tabs: AssetTabItem[];
  activeTab: AssetTabId;
  onSelectTab: (id: AssetTabId) => void;
}

// Availability is decided by the caller: the page builds `tabs` from
// zillow3d / showStagedTab / canDelete before handing it down. This widget
// never re-derives visibility -- it renders whatever tabs it's given.
const AssetsTabList = ({ tabs, activeTab, onSelectTab }: AssetsTabListProps) => (
  <div data-testid="asset-view-tabs" className="flex gap-8 min-w-0">
    {tabs.map((tab) => {
      const isActive = tab.id === activeTab;
      return (
        <button
          key={tab.id}
          onClick={() => onSelectTab(tab.id)}
          className={`cursor-pointer py-3 text-base font-medium border-b-2 transition-colors whitespace-nowrap shrink-0 ${
            isActive
              ? 'border-primary text-primary'
              : 'border-transparent text-muted-foreground hover:text-foreground'
          }`}
        >
          {tab.label}
          {tab.count !== undefined && (
            <TabCountBadge count={tab.count} active={isActive} />
          )}
        </button>
      );
    })}
  </div>
);

export default AssetsTabList;
